import React from "react";
import "./StepperComponent.scss";
import { Box } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const StepperComponent = ({ activeStep = 0, steps = [] }) => {

  return (
    <div className="custom-stepper">
      {steps.map((label, index) => {
        const isActive = index === activeStep;
        const isCompleted = index < activeStep;

        return (
          <div className="step" key={label["id"]}>
            {!isCompleted && (
              <div
                className={`step-circle ${
                  isCompleted ? "completed" : isActive ? "active" : ""
                }`}
              >
                {index + 1}
              </div>
            )}
            <div
              className={`step-label ${
                isCompleted ? "completed" : isActive ? "active" : "inactive"
              }`}
            >
              {label["title"]}{" "}
              {isCompleted && (
                <CheckCircleIcon height="20px"
                width="20px" />
              )}
            </div>
            {index < steps.length - 1 && <div className="step-divider" />}
          </div>
        );
      })}
    </div>
  );
};

export default StepperComponent;
